import { HomeworkSubmittedPage } from './HomeworkSubmittedPage';
export default HomeworkSubmittedPage;
